import { IconButton } from '@material-ui/core'
import { Link } from 'react-router-dom'

import { Dropdown } from '../../../../Dropdown'
import { Icon } from '../../../../Icon'

import * as S from './styles'

type IndustryDropdownProps = {
  id: string
  setDeleteIndustry: () => void
}

export const IndustryDropdown = ({
  id,
  setDeleteIndustry
}: IndustryDropdownProps) => {
  return (
    <S.Wrapper>
      <Dropdown
        title={
          <IconButton
            id="action"
            color="inherit"
            aria-label="open drawer"
            onClick={() => {}}
            size="medium"
            edge="start"
          >
            <Icon
              icon="itens-interface-actions"
              width={12}
              height={12}
              aria-label="action"
            />
          </IconButton>
        }
      >
        <S.Nav>
          <Link to={`/industria/editar/${id}`}>
            <S.Link>
              <Icon icon="dropdown-edit" height={16} width={16}></Icon>
              <span>Editar</span>
            </S.Link>
          </Link>
          <S.Link onClick={setDeleteIndustry}>
            <Icon icon="dropdown-delete" height={16} width={16}></Icon>
            <span>Excluir</span>
          </S.Link>
        </S.Nav>
      </Dropdown>
    </S.Wrapper>
  )
}
